import { render } from "storyblok-rich-text-react-renderer";

export default function RichText({ document }) {
  return <div className="richText lg:text-xl">{render(document)}</div>;
}
